import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=021a2008&scoped=true&"
import script from "./Competitors.vue?vue&type=script&lang=ts&"
export * from "./Competitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a2008",
  null
  
)

export default component.exports